<template>
  <div class="import-page" v-loading="pageloading">

    <div class="page-right-top-btn">
      <el-link type="primary" href="static/Inport.xlsx" target="_blank">{{ $t('activebrand.t46') }}</el-link>
      <el-upload
        :show-file-list="false"
        class="upload-excle-box"
        :action="uploadurl"
        :data="{taskid: this.current.taskid}"
        :limit="1"
        :on-progress="uploadingExcel"
        :on-success="uploadExcel"
        name="excelFile"
        accept=".xls, .xlsx">
        <el-button plain 
          type="danger" 
          size="mini"
        >
          上传Excel
        </el-button>
      </el-upload>
      <el-button type="primary" size="mini" @click="onClickDownload()" :loading="downloading">下载数据</el-button>
      <el-button type="danger" size="mini" @click="onClickUpload()">{{ $t('import.s6') }}</el-button>
    </div>

    <div class="import-content">
      <el-tabs v-model="activeName" type="card" @tab-click="changetabs">
        <el-tab-pane :label="tabname[0]" name="first">
          <div class="tablebox">
            <el-table :cell-style="getTableCellStyle" :data="linksdata[1]" tooltip-effect="dark" 
              style="width: 100%" size="mini" v-loading="loading">
              <el-table-column label="Link ID" prop="ClientLinkID" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="具体链接" prop="URL" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.URL }}</a>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" prop="InsertTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="最近监测时间" prop="UpdateTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="状态" prop="Status" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s8')" @confirm="updateStatus(scope.row, 6)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-video-pause"></i>
                    </el-button>
                  </el-popconfirm>
                  <el-popconfirm :title="$t('import.s9')" @confirm="updateStatus(scope.row, 5)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        
        <el-tab-pane :label="tabname[1]" name="second">
          <div class="tablebox">
            <el-table :cell-style="getTableCellStyle" :data="linksdata[2]" tooltip-effect="dark" 
              style="width: 100%" size="mini" v-loading="loading">
              <el-table-column label="Link ID" prop="ClientLinkID" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="具体链接" prop="URL" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.URL }}</a>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" prop="InsertTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="最近监测时间" prop="UpdateTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="状态" prop="Status" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s8')" @confirm="updateStatus(scope.row, 6)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-video-pause"></i>
                    </el-button>
                  </el-popconfirm>
                  <el-popconfirm :title="$t('import.s9')" @confirm="updateStatus(scope.row, 5)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane :label="tabname[2]" name="third">
          <div class="tablebox">
            <el-table :cell-style="getTableCellStyle" :data="linksdata[4]" tooltip-effect="dark" 
              style="width: 100%" size="mini" v-loading="loading">
              <el-table-column label="Link ID" prop="ClientLinkID" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="具体链接" prop="URL" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.URL }}</a>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" prop="InsertTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="最近监测时间" prop="UpdateTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="状态" prop="Status" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s8')" @confirm="updateStatus(scope.row, 6)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-video-pause"></i>
                    </el-button>
                  </el-popconfirm>
                  <el-popconfirm :title="$t('import.s9')" @confirm="updateStatus(scope.row, 5)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane :label="tabname[3]" name="four">
          <div class="tablebox">
            <el-table :cell-style="getTableCellStyle" :data="linksdata[0]" tooltip-effect="dark" 
              style="width: 100%" size="mini" v-loading="loading">
              <el-table-column label="Link ID" prop="ClientLinkID" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="具体链接" prop="URL" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.URL }}</a>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" prop="InsertTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="最近监测时间" prop="UpdateTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="状态" prop="Status" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s8')" @confirm="updateStatus(scope.row, 6)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-video-pause"></i>
                    </el-button>
                  </el-popconfirm>
                  <el-popconfirm :title="$t('import.s9')" @confirm="updateStatus(scope.row, 5)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane :label="tabname[4]" name="five">
          <div class="tablebox">
            <el-table :cell-style="getTableCellStyle" :data="linksdata[3]" tooltip-effect="dark" 
              style="width: 100%" size="mini" v-loading="loading">
              <el-table-column label="Link ID" prop="ClientLinkID" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="具体链接" prop="URL" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.URL }}</a>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" prop="InsertTime" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="最近监测时间" prop="UpdateTime" width="150" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column label="状态" prop="Status" width="100" show-overflow-tooltip></el-table-column> -->
              <el-table-column label="失败原因" prop="Reason" width="200" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s8')" @confirm="updateStatus(scope.row, 6)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-video-pause"></i>
                    </el-button>
                  </el-popconfirm>
                  <el-popconfirm :title="$t('import.s9')" @confirm="updateStatus(scope.row, 5)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="query.size"
          :current-page.sync="query.page"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>
    </div>

    <el-dialog
      custom-class="editskulink-datafeedback"
      :title="$t('import.s19')"
      :visible.sync="showuploaddialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="showchannelicon = false; updatesuccessful=false; uploadurls=''; urlslength=0">
      <div class="editskulink-body" v-if="false === updatesuccessful" v-loading.fullscreen.lock="importloading">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="$t('import.s11')"
          resize="none"
          v-model="uploadurls"
          @input.native="onInputChange">
        </el-input>
      </div>
      <span slot="footer" v-if="false === updatesuccessful" class="dialog-footer">
        <el-button size="mini" @click="showuploaddialog = false; uploadurls=''">{{$t('dsfx.t32')}}</el-button>
        <el-button size="mini" type="primary" @click="uploadLink()">{{$t('dsfx.t33')}}</el-button>
      </span>
      <div class="editskulink-body" v-if="true === updatesuccessful">
        <el-result icon="success" :title="$t('import.s18')">
          <template slot="extra">
            <p>{{ $t('import.s16') }}</p>
          </template>
        </el-result>
      </div>
      <span slot="footer" v-if="true === updatesuccessful" class="dialog-footer">
        <el-button size="mini" type="primary" @click="showuploaddialog = false; uploadurls=''">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { Loading } from 'element-ui'
let fullscreenLoading = null
export default {
  data(){
    return{
      current: this.getCurrentInfo(),
      pageloading: false,
      importloading: false,
      showuploaddialog: false,
      updatesuccessful: false,
      uploadurls: '',
      query: {
        taskid: '',
        page: 1,
        size: 25,
        status: 2
      },
      pagingtotal: 0,
      statuscount: [],
      tabname: ['活跃链接', '失效链接', '已删除', '处理中', '导入失败'],
      linksdata: [[], [], [], [], []],
      activeName: 'first',
      loading: false,
      uploadurl: this.API_URL + '/v3/importlink/statistics/uploadlinkList',
      downloading: false
    }
  },

  mounted(){
    this.loadPage()
  },

  methods: {

    /**
     * 加载页面
     */
    loadPage: function(){
      this.getLinkslist(2)
      this.getStatusCount()
    },

    /**
     * 获取各个状态数据统计
     */
    getStatusCount: function(){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/findLinkCount?taskid=' + that.current.taskid
      $.ajax({
        url: url,
        type: "GET",
        success: function(data) {
          let _status = data.results[0]
          let s1 = _status.status1 != null ? _status.status1 : 0
          let s2 = _status.status2 != null ? _status.status2 : 0
          let s3 = _status.status3 != null ? _status.status3 : 0
          let s4 = _status.status4 != null ? _status.status4 : 0
          let s5 = _status.status5 != null ? _status.status5 : 0
          that.tabname = [
          '活跃链接(' + s2 + ')', 
          '失效链接(' + s3 + ')', 
          '已删除(' + s5 + ')', 
          '处理中(' + s1 + ')', 
          '导入失败(' + s4 + ')'
          ]
        },
        error: function(response) {
          console.log('getStatusCount',response)
        }
      })
    },

    /**
     * 获取数据列表
     */
    getLinkslist: function(status){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/monitorlinkList'
      let _query = {
        taskid: that.current.taskid,
        page: that.query.page,
        size: that.query.size,
        status: status
      }
      that.loading = that.linksdata[status=='0,1' ? 0 : status-1] != [] ? true : false
      // that.pagingtotal = 0
      $.ajax({
        url: url,
        type: "GET",
        data: _query,
        success: function(data) {
          let _data = data.results[1]
          _data.forEach(item => {
            item.InsertTime = item.InsertTime != null ? that.$moment(item.InsertTime).utc(8).format('YYYY-MM-DD HH:mm') : ''
            item.UpdateTime = item.UpdateTime != null ? that.$moment(item.UpdateTime).utc(8).format('YYYY-MM-DD HH:mm') : ''
            item.Status = that.formatStatus(item.Status)
          })
          that.linksdata[status=='0,1' ? 0 : status-1] = data.results[1]
          /**
           * 展示和数据不对应
           * 0,1 : [0] : 处理中
           * 2   : [1] : 活跃链接
           * 3   : [2] : 失效链接
           * 4   : [3] : 导入失败
           * 5   : [4] : 已删除
           */
          that.pagingtotal = data.results[0][0].Count
          that.loading = false
        },
        error: function(response) {
          console.log('getLinkslist',response)
        }
      })
    },

    /**
     * 通用切换按钮
     */
    tabsType: function(){
      let that = this
      if(that.activeName == 'first'){
        that.getLinkslist(2)
      }
      if(that.activeName == 'second'){
        that.getLinkslist(3)
      }
      if(that.activeName == 'third'){
        that.getLinkslist(5)
      }
      if(that.activeName == 'four'){
        that.getLinkslist('0,1')
      }
      if(that.activeName == 'five'){
        that.getLinkslist(4)
      }
    },

    /**
     * 切换tabs
     */
    changetabs: function(){
      this.query.page = 1
      this.tabsType()
    },
    
    /**
     * 分页
     */
    handleSizeChange: function(val){
      this.query.page = 1
      this.query.size = val
      this.tabsType()
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(val){
      this.query.page = val
      this.tabsType()
    },

    /**
     * 点击上传
     */
    onClickUpload: function(){
      this.showuploaddialog = true
    },

    /**
     * 监听输入事件
     */
    onInputChange: function(){
      let that = this
      let _urls = that.uploadurls.split(/[(\r\n\s)\r\n\s]+/).filter(Boolean)
      that.urlslength = _urls.length >= 50 ? 50 : _urls.length
      if(_urls.length >= 50){
        let _uploadurls = _urls.slice(0, 50)
        that.uploadurls = _uploadurls.join('\n')
      }
    },
    
    /**
     * 上传
     */
    uploadLink: function(){
      let that = this
      that.importloading = true
      let url = that.API_URL + '/v3/importlink/statistics/addmonitorlink'
      let _query = {
        taskid: that.current.taskid,
        linkList: that.uploadurls.split(/[(\r\n\s)\r\n\s]+/)
      }
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(_query),
        success: function(data) {
          if(data.success == true){
            that.importloading = false
            that.updatesuccessful = false
          }
        },
        error: function(response) {
          console.log('importLists',response)
        }
      })      
    },

    /**
     * 暂停 & 删除
     */
    updateStatus: function(row, status){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/updatemonitorlinkList'
      let _query = {
        ImportID: row.ImportID,
        status: status
      }
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(_query),
        success: function(data) {
          that.$message({
            message: data.results,
            type: 'success'
          })
          that.loadPage()
        },
        error: function(response) {
          console.log('updateStatus',response)
        }
      })
    },

    /**
     * 格式化状态
     */
    formatStatus: function(s){
      let _status = ''
      switch(s){
        case 0: case  1:
          _status = '处理中'
          break;
        case 2:
          _status = '活跃链接'
          break;
        case 3:
          _status = '失效链接'
          break;
        case 4:
          _status = '导入失败'
          break;
        case 5:
          _status = '已删除'
          break;
        case 6:
          _status = '已暂停'
          break;
        default:
          _status = '';
          break;
      }
      return _status
    },

    /**
     * uploadingExcel
     */
    uploadingExcel: function(){
      fullscreenLoading = Loading.service({
        lock: true,
        text: '数据上传中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)'
      })
    },

    /**
     * 上传Excel文件成功
     */
    uploadExcel: function(){
      let that = this
      fullscreenLoading.close()
      that.$message({
        message: '导入成功',
        type: 'success'
      })
      that.loadPage()
    },

    /**
     * 下载数据
     */
    onClickDownload: function(){
      let that = this
      that.downloading = true
      let url = that.API_URL + '/v3/importlink/statistics/downloadLink'
      let filename = that.$moment(new Date(),'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYYMMDDHHmm')
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
            that.downloading = false
          }
        }
      }
      xhr.send()
    },

  }
}
</script>